<template>
  <div class="zhanwei4"></div>
  <div class="role">
    <div class="addRole2" v-for="(item, index) in roles" :key="index">
      <p>{{ item.roleName }}</p>
      <el-image :src="item.roleImg" fit="contain" style="width: 100%" />
      <div style="margin-top: 10px">
        <el-button
          type="primary"
          @click="
            editRole(index);
            this.isUpdate = true;
          "
          >编辑</el-button
        >
        <el-popconfirm title="确认删除?" @confirm="deleteRole(index)">
          <template #reference>
            <el-button type="danger">删除</el-button>
          </template>
        </el-popconfirm>
      </div>
    </div>
    <div
      class="addRole"
      @click="
        this.customDraggingVisible = true;
        this.form = [];
        this.isUpdate = false;
        this.fileList = [];
      "
    >
      <img src="../../image/add.svg" alt="" />
      <p>添加角色</p>
    </div>
  </div>

  <el-dialog
    v-model="customDraggingVisible"
    class="custom-dragging-style"
    title="建立角色"
    width="1000"
    draggable
    :close-on-click-modal="false"
  >
    <div class="role_add">
      <div class="role_add_left" style="width: 50%">
        <div class="role_add_left_top">
          <div style="margin: 10px 0">角色图片</div>
          <el-upload
            v-model:file-list="fileList"
            :action="UpdateApi"
            list-type="picture-card"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            limit="1"
          >
            <el-icon><Plus /></el-icon>
          </el-upload>
          <div style="margin: 10px 0">
            图片上传格式为 JPG/PNG/GIF，建议尺寸 1080*1920px
          </div>
        </div>
        <div class="role_add_left_bottom">
          <el-form
            :model="form"
            label-width="auto"
            label-position="top"
            style="width: 90%"
          >
            <el-form-item label="角色名称">
              <el-input v-model="form.name" maxlength="20" />
            </el-form-item>
            <el-form-item label="性别">
              <el-input v-model="form.sex" maxlength="20" />
            </el-form-item>
            <el-form-item label="年龄">
              <el-input v-model="form.age" maxlength="20" />
            </el-form-item>
            <el-form-item label="职业">
              <el-input v-model="form.profession" maxlength="20" />
            </el-form-item>
            <el-form-item label="特殊技能">
              <el-input
                v-model="form.skill"
                type="textarea"
                show-word-limit
                maxlength="200"
              />
            </el-form-item>
            <el-form-item label="角色描述">
              <el-input
                v-model="form.desc"
                type="textarea"
                show-word-limit
                maxlength="200"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="role_add_right" style="width: 50%">
        <div class="role_add_right_show">
          <p>
            <el-image
              :src="form.img"
              alt=""
              fit="contain"
              style="height: 100%"
            />
          </p>
          <p>角色名称:&nbsp;&nbsp;&nbsp;{{ form.name }}</p>
          <p>性别:&nbsp;&nbsp;&nbsp;{{ form.sex }}</p>
          <p>年龄:&nbsp;&nbsp;&nbsp;{{ form.age }}</p>
          <p>职业:&nbsp;&nbsp;&nbsp;{{ form.profession }}</p>
          <p>特殊技能:&nbsp;&nbsp;&nbsp;{{ form.skill }}</p>
          <p>性格描述:&nbsp;&nbsp;&nbsp;{{ form.desc }}</p>
          <p>
            <span>继续</span>
          </p>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="customDraggingVisible = false">取消</el-button>
        <el-button type="primary" @click="isUpdate ? updateRole() : addRole()">
          {{ isUpdate ? "编辑" : "添加" }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { Plus } from "@element-plus/icons-vue";
import { ElNotification } from "element-plus";

export default {
  name: "RoleScroll",
  components: {
    Plus,
  },
  props: {},
  data() {
    return {
      customDraggingVisible: false,
      fileList: [],
      textarea1: "",
      textarea2: "",
      isUpdate: false,
      form: {
        id: "",
        name: "",
        desc: "",
        img: "",
        sex: "",
        profession: "",
        age: "",
        skill: "",
      },
      roles: [],
    };
  },
  computed: {
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  methods: {
    init() {
      this.$store
        .dispatch("game/getRoles", { gameId: this.$route.params.id })
        .then((res: any) => {
          this.roles = res;
          this.customDraggingVisible = false;
          this.form = {};
          this.fileList = [];
        })
        .catch(() => {});
    },
    beforeAvatarUpload(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传png/jpg",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于5m",
          offset: 100,
          duration: 3000,
        });
        return false;
      }

      return true;
    },
    handleAvatarSuccess(response: any) {
      this.form.img = response.data.returnFileUrl;
    },
    addRole() {
      this.$store
        .dispatch("game/saveRole", {
          gameId: this.$route.params.id,
          roleDesc: this.form.desc,
          roleImg: this.form.img,
          roleName: this.form.name,
          roleAge: this.form.age,
          roleSex: this.form.sex,
          roleProfession: this.form.profession,
          roleSkill: this.form.skill,
        })
        .then((res: any) => {
          this.init();
        })
        .catch(() => {});
    },
    editRole(index: number) {
      console.log(this.roles[index]);
      this.form.desc = this.roles[index].roleDesc;
      this.form.name = this.roles[index].roleName;
      this.form.img = this.roles[index].roleImg;
      this.form.id = this.roles[index].roleId;
      this.form.age = this.roles[index].roleAge;
      this.form.sex = this.roles[index].roleSex;
      this.form.profession = this.roles[index].roleProfession;
      this.form.skill = this.roles[index].roleSkill;
      this.fileList = [];
      this.fileList.push({
        name: "food.jpg",
        url: this.roles[index].roleImg,
      });
      this.customDraggingVisible = true;
    },
    deleteRole(index: number) {
      this.$store
        .dispatch("game/delRole", {
          ids: [this.roles[index].roleId],
        })
        .then((res: any) => {
          this.init();
        })
        .catch(() => {});
    },
    updateRole() {
      this.$store
        .dispatch("game/updRole", {
          roleId: this.form.id,
          gameId: this.$route.params.id,
          roleDesc: this.form.desc,
          roleImg: this.form.img,
          roleName: this.form.name,
          roleAge: this.form.age,
          roleSex: this.form.sex,
          roleProfession: this.form.profession,
          roleSkill: this.form.skill,
        })
        .then((res: any) => {
          this.init();
        })
        .catch(() => {});
    },
  },
  watch: {},
  created() {},
  mounted() {
    this.init();
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
};
</script>

<style scoped lang="less">
// 清除默认的滚动条样式（可选，提升美观度）
::-webkit-scrollbar {
  height: 6px; // 横向滚动条高度
}
::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 3px;
}
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}

.role {
  width: 100%;
  height: 80vh;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex; // flex布局
  align-items: center; // 垂直居中（核心）
  flex-wrap: nowrap; // 横向不换行（替代white-space）

  .addRole {
    width: 260px;
    height: 400px;
    border: 2px dashed #a8a8a8;
    margin-left: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &:first-child {
      margin-left: 20px;
    }

    img {
      width: 30%;
    }
  }

  .addRole2 {
    width: 260px;
    height: 400px;
    margin-left: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    &:first-child {
      margin-left: 20px;
    }

    img {
      width: 30%;
    }
  }
}

.role_add {
  display: flex;
  justify-content: center;
  align-items: center;
  &_left {
    &_bottom {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 10px;
    }
  }

  &_right {
    display: flex;
    justify-content: center;
    align-items: center;
    &_show {
      width: 260px;
      height: 560px;
      box-shadow: 0px 0px 5px #e3e3e3;

      p {
        &:nth-child(1) {
          width: 100%;
          height: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5) {
          width: 100%;
          height: 4%;
          margin-left: 15px;
          line-height: 233%;
        }
        &:nth-child(7),
        &:nth-child(6) {
          width: 90%;
          height: 10%;
          margin-left: 15px;
          overflow-y: scroll;
        }

        &:nth-child(8) {
          width: 100%;
          height: 14%;
          display: flex;
          justify-content: center;
          align-items: center;

          span {
            width: 80px;
            height: 40px;
            background: #02a7e5;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
